import { Sidepanel } from "pepsico-ds";
import SelectionTable from "./SelectionTable";
import { useState, useEffect, useRef } from "react";

import { useSelector } from "react-redux";
import { getAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
import "./SectionSidePanel.css";
import SelectionHeader from "./SelectionHeader";
const SelectionSidePanel = ({
  open,
  setOpen,
  type,
  handleRowSelection,
  selectedItems,
  flagConfig,
}) => {
  const [selectedRows, setSelectedRows] = useState(
    type ? selectedItems?.[type] || [] : selectedItems || []
  );
  const [search, setSearch] = useState("");
  const { subjectFilter } = useSelector((store) => store.internalFilter);
  const [subject, setSubject] = useState("");
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchapi = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { documentFlag, videoFlag, linkFlag } = flagConfig;
        const response = await getAPI(
          `${BASE_URL}/curator/filter/find-all-approved-contents?documentFlag=${documentFlag}&videoFlag=${videoFlag}&linkFlag=${linkFlag}`
        );

        if (response?.status === 200) {
          setRowData(response?.data?.response);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (!fetchapi.current) {
      fetchapi.current = true;
      fetchData();
    }
  }, [flagConfig]);

  useEffect(() => {
    if (type) {
      setSelectedRows(selectedItems?.[type] || []);
    } else {
      setSelectedRows(selectedItems || []);
    }
    setSubject(""); // reset subject filter
    setSearch(""); // reset search
  }, [open, selectedItems, type]);

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    if (type) {
      handleRowSelection(type, selectedRows);
    } else {
      handleRowSelection(selectedRows);
    }
    setOpen(false);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };
  const handleSubject = (value) => {
    setSubject(value);
  };

  return (
    <Sidepanel
      className="side"
      horizontalSidepanelWidth="400px"
      showSidePanel={open}
      onCloseSidePanel={handleModalClose}
      primaryButtonProps={{
        onClick: handleApply,
        size: "medium",
        text: "Add content",
        variant: "primary",
      }}
      secondaryButtonProps={{
        onClick: handleModalClose,
        size: "medium",
        text: "Cancel",
        variant: "secondary",
      }}
      showFooter
      showLink={false}
      showSecondaryButton
      showTertiaryButton={false}
      style={{}}
      title="Add Content"
      type="horizontal"
      verticalSidepanelHeight="80%"
    >
      <SelectionHeader
        selectedRows={selectedRows}
        handleSearch={handleSearch}
        handleSubject={handleSubject}
        subjectFilter={subjectFilter}
      />

      <SelectionTable
        onSelection={(rows) => setSelectedRows(rows)}
        selectedRows={selectedRows}
        type={type}
        search={search}
        subject={subject}
        rowData={rowData}
        loading={loading}
      />
    </Sidepanel>
  );
};

export default SelectionSidePanel;
